import client from '../api/client';

export const login = (credentials) =>
  client.post('/auth/login', { ...credentials, portal: 'ADMIN' });

export const refresh = (refreshToken) =>
  client.post('/auth/refresh', { refreshToken });

export const logout = () => client.post('/auth/logout');

export const getMe = () => client.get('/auth/me');
